/**
 * Maps response field keys (AI or OCR) to their corresponding form field IDs.
 *
 * Key   = field key as it appears in the response (matched case-insensitively at runtime)
 * Value = form field ID as defined in FieldDefinition.id
 *
 * Only add an entry when the response key differs from the form field ID.
 * Fields whose response key already matches their form field ID need no entry here.
 */
export const FIELD_RESPONSE_MAPPING: Record<string, string> = {
    'type_of_body': 'ambulance_type',
    'wheelType': 'osRearWheelType',
    'vehicle_type': 'use',
    'running_board': 'running_board',
    'grilleGuard': 'grille_guard',
    'Rear Axle Rating': 'rearAxleRating',
    'rear axle rating': 'rearAxleRating',
}

/**
 * Explicit AI value → dropdown option overrides, keyed by form field ID.
 *
 * Use this when the generic matching algorithm (contains / word-overlap) still
 * fails to resolve an AI-returned value to the correct dropdown option —
 * typically for abbreviations or true synonyms.
 *
 * Key   = form field ID (FieldDefinition.id)
 * Value = map of { AI returned value (case-insensitive) → exact dropdown option label }
 *
 * Aliases are checked before the algorithm, so they always take precedence.
 */
export const FIELD_VALUE_ALIASES: Record<string, Record<string, string>> = {
    osRearWheelType: {
        'Steel': 'Steel Disc',
        'Aluminum': 'Aluminum Disc'
    },
    ambulance_type: {
        'Type 1': 'I',
        'Type 2': 'II'
    },
    // Toggle fields: AI returns the feature name when detected (e.g. "Ramp" means ramp is present)
    ramp: {
        'Ramp': 'true',
    },
    running_board: {
        'Running Board': 'true',
    },
    belly_boxes: {
        'Belly Boxes': 'true',
    },
    nose_cone:{
      'Nose Cone': 'true',
    },
    cms:{
      'CMS': 'true',
    },
    trimLevel: {
        'std' : 'Standard'
    },
    lube_skid: {
        'Lube Skid': 'true',
    },
    metal_delivery_shelving: {
        'Metal Delivery Shelving': 'true',
    },
    backup_camera: {
        'Backup Camera': 'true',
    }

}
